import { render, staticRenderFns } from "./RecommendationsComponent.vue?vue&type=template&id=4fb2a0b2"
import script from "./RecommendationsComponent.vue?vue&type=script&lang=ts"
export * from "./RecommendationsComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports